import _ from "lodash";
import { make } from "vuex-pathify";
import loader from "@/util/loader";
import api from "@/util/api";

const initialState = {
    changeVehicle: {
        data: {
            exteriorColor: "",
            imageUrl: null,
            interiorColor: "",
            inventoryId: "",
            invoice: 0,
            make: "",
            model: "",
            msrp: 0,
            sellingPrice: 0,
            show: false,
            stockNumber: 0,
            vehicleType: "",
            vin: "",
            year: 0,
            availableDealTypes: [],
        },
        loader: loader.defaultState(),
    },
    stockAndVinForm: {
        isValid: false,
        stockNumber: null,
        vin: null,
        errorMessage: null,
        loader: loader.defaultState(),
    },
    deal: {
        data: null,
        loader: loader.defaultState(),
    },
};

const mutations = {
    ...make.mutations(initialState),
    SET_STOCK_AND_VIN_FORM_LOADER: (state, payload) => {
        state.stockAndVinForm.loader = payload;
    },
    SET_STOCK_AND_VIN_FORM_ERROR_MESSAGE: (state, payload) => {
        state.stockAndVinForm.errorMessage = payload;
    },
    SET_CHANGE_VEHICLE: (state, payload) => {
        state.changeVehicle.data = payload;
    },
    SET_CHANGE_VEHICLE_SHOW: (state, payload) => {
        state.changeVehicle.data.show = payload;
    },
    SET_FORM_IS_VALID: (state, value) => {
        state.stockAndVinForm.isValid = value;
    },
    UPDATE_STOCK_NUMBER: (state, value) => {
        state.stockAndVinForm.stockNumber = value;
    },
    UPDATE_VIN: (state, value) => {
        state.stockAndVinForm.vin = value;
    },
    RESET_STOCK_AND_VIN_FORM: (state) => {
        state.changeVehicle.data.show = false;
        state.stockAndVinForm = {
            isValid: false,
            stockNumber: null,
            vin: null,
            errorMessage: null,
            loader: loader.defaultState(),
        };
    },
    RESET_FORM_EDIT_VEHICLE: (state) => {
        state.stockAndVinForm.errorMessage = null;
        state.changeVehicle.data.show = false;
    },
    SET_DEAL: (state, payload) => {
        state.deal.data = payload;
    },
    SET_DEAL_LOADER: (state, payload) => {
        state.deal.loader = payload;
    },
};

const actions = {
    fetchVehicle({ commit, state }, { dealerId, userId }) {
        commit("SET_STOCK_AND_VIN_FORM_LOADER", loader.started());
        let requestParams = `?dealerId=${dealerId}`;

        if (state.stockAndVinForm.stockNumber) {
            requestParams += `&stockNumber=${state.stockAndVinForm.stockNumber}`;
        }

        if (state.stockAndVinForm.vin) {
            requestParams += `&vin=${state.stockAndVinForm.vin}`;
        }

        if (userId && userId !== "") {
            requestParams += `&userId=${userId}`;
        }

        const result = api
            .get(`/vehicle/retrieve` + requestParams)
            .then((response) => {
                console.log("response =", response.data);
                commit("SET_CHANGE_VEHICLE", response.data);
                commit("SET_CHANGE_VEHICLE_SHOW", true);
                commit("SET_STOCK_AND_VIN_FORM_LOADER", loader.successful());
            })
            .catch((error) => {
                if (error.response) {
                    commit("SET_STOCK_AND_VIN_FORM_ERROR_MESSAGE", error.response.data);
                } else {
                    console.error("Error", error.message);
                }
                commit("SET_STOCK_AND_VIN_FORM_LOADER", loader.error(error));
            });

        return result;
    },
    fetchVehicleByProgramId({ commit, state }, { programId, dealerId }) {
        commit("SET_STOCK_AND_VIN_FORM_LOADER", loader.started());
        let requestParams = `?programId=${programId}`;

        if (dealerId) {
            requestParams += `&dealerId=${dealerId}`;
        }

        if (state.stockAndVinForm.stockNumber) {
            requestParams += `&stockNumber=${state.stockAndVinForm.stockNumber}`;
        }

        if (state.stockAndVinForm.vin) {
            requestParams += `&vin=${state.stockAndVinForm.vin}`;
        }

        const result = api
            .get(`/vehicle/retrieve/byProgramWithActiveProgramSubscriptions` + requestParams)
            .then((response) => {
                console.log("response programmm =", response.data);
                commit("SET_CHANGE_VEHICLE", response.data);
                commit("SET_CHANGE_VEHICLE_SHOW", true);
                commit("SET_STOCK_AND_VIN_FORM_LOADER", loader.successful());
            })
            .catch((error) => {
                if (error.response) {
                    commit("SET_STOCK_AND_VIN_FORM_ERROR_MESSAGE", error.response.data);
                } else {
                    console.error("Error", error.message);
                }
                commit("SET_STOCK_AND_VIN_FORM_LOADER", loader.error(error));
            });

        return result;
    },
    checkIfStockAndVinFormIsValid({ commit, state }) {
        if (!state.stockAndVinForm.stockNumber && !state.stockAndVinForm.vin) {
            const message = "Please provide a VIN or stock number!";
            commit("SET_STOCK_AND_VIN_FORM_ERROR_MESSAGE", message);
            commit("SET_FORM_IS_VALID", false);
        } else {
            commit("SET_FORM_IS_VALID", true);
        }
    },
    updateStockNumber({ commit }, value) {
        commit("UPDATE_STOCK_NUMBER", value);
    },
    updateVin({ commit }, value) {
        commit("UPDATE_VIN", value);
    },
    resetStockAndVinForm({ commit }) {
        commit("RESET_STOCK_AND_VIN_FORM");
    },
    resetEditVehicleForm({ commit }) {
        commit("RESET_FORM_EDIT_VEHICLE");
    },
    createDeal({ commit, state }, createDealRequest) {
        commit("SET_DEAL_LOADER", loader.started());
        const result = api
            .post(`/create-deal`, createDealRequest)
            .then((response) => {
                console.log("create deal response =", response.data);
                commit("SET_DEAL", response.data);
                commit("SET_DEAL_LOADER", loader.successful());
            })
            .catch((error) => {
                console.error("Error", error.message);
                commit("SET_DEAL_LOADER", loader.error(error));
            });

        return result;
    },
};

const getters = {
    isEnvironmentProd: () => {
        const environment = _.get(window, "_APP_CONFIG.env[0]", "local") || "local";
        return environment === "prod";
    },
};

export default {
    namespaced: true,
    state: initialState,
    actions,
    mutations,
    getters,
};
